import * as bootstrap from 'bootstrap';

export async function initConfirmModal(parent: HTMLElement | Document): Promise<void> {
  const btns = parent.querySelectorAll<HTMLElement>('.btn-confirm');
  initConfirmButtons(btns);
}

export async function initConfirmButtons(
  btns: NodeListOf<HTMLElement> | HTMLElement[]
): Promise<void> {
  if (!btns || btns.length === 0) return;

  const defaultTarget = '#confirmModal';
  const modal = document.querySelector<HTMLElement>(defaultTarget);
  if (!modal) return;

  const confirmForm = modal.querySelector<HTMLFormElement>('.confirm-form');
  if (!confirmForm) {
    // eslint-disable-next-line no-console
    console.warn('Confirm form not found in modal.');
    return;
  }

  const messageWrapper = modal.querySelector<HTMLElement>('.message-wrapper');
  if (!messageWrapper) {
    // eslint-disable-next-line no-console
    console.warn('Message wrapper not found in modal.');
    return;
  }

  for (const btn of btns) {
    btn.addEventListener('click', function (_e) {
      const message =
        btn.getAttribute('data-biz-message') || modal.getAttribute('data-default-message') || '';
      const action = btn.getAttribute('data-biz-action');
      const method = btn.getAttribute('data-biz-method') || 'POST';
      const target = btn.getAttribute('data-biz-target') || defaultTarget;

      if (action) {
        confirmForm.setAttribute('action', action);
      }
      confirmForm.setAttribute('method', method);
      messageWrapper.innerHTML = message;

      const backButton = modal.querySelector<HTMLElement>('.btn-back');
      if (backButton) {
        backButton.removeAttribute('data-bs-toggle');
        backButton.removeAttribute('data-bs-target');
      }

      const parentModal = btn.closest<HTMLElement>('.modal');
      if (parentModal) {
        if (backButton) {
          backButton.setAttribute('data-bs-toggle', 'modal');
          backButton.setAttribute('data-bs-target', `#${parentModal.id}`);
        }
        const bsParentModal = bootstrap.Modal.getInstance(parentModal);
        if (bsParentModal) {
          bsParentModal.hide();
        }
      }

      const targetModal = document.querySelector<HTMLElement>(target);
      if (targetModal) {
        const bsTargetModal = new bootstrap.Modal(targetModal);
        bsTargetModal.show();
      }
    });
  }
}
